import {Options} from "highcharts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class BarBase extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'bar',
                marginRight: 40,
                marginLeft: 30,
                spacingBottom: 0,
                spacingTop: 10,
                width: 500,
                height: 250,
            },
            xAxis: {
                labels: {
                    enabled: false,
                },
                lineColor: '#ccc',
            },
            yAxis: {
                labels: {
                    style: {
                        "color": "black",
                        "fontSize": "12px"
                    }
                },
                min: 0,
                max: 100,
                tickInterval: 10,
                gridLineColor: '#ccc',
                tickPositions: [0, 1, 2, 3, 4, 5],
                opposite: true,
            },
            plotOptions: {
                bar: {
                    borderWidth: 0,
                    pointWidth: 18
                }
            },
        };

        return super.mergeOptions(super.allChartOptions(), options);
    }
}
